<template>
    <v-container fluid>
        <!-- v-row class="text-center">
            <v-flex xs12>
                <h1>System Utilities</h1>
            </v-flex>
        </v-row -->
        <UtilityForm />
    </v-container>
</template>

<script>
import UtilityForm from '@/components/UtilityForm.vue'

export default {
    name: 'Utility',
    components: {
        UtilityForm,
    },
}
</script>